/**
 * Collections Page JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // FAQ Accordion functionality
  const faqItems = document.querySelectorAll('.faq-item');
  
  if (faqItems.length > 0) {
    // Optional: Close other FAQs when one is opened (accordion behavior)
    faqItems.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (this.open) {
          // Close all other FAQ items
          faqItems.forEach(function(otherItem) {
            if (otherItem !== item && otherItem.open) {
              otherItem.open = false;
            }
          });
        }
      });
    });
    
    // Optional: Smooth scroll to opened FAQ
    faqItems.forEach(function(item) {
      const summary = item.querySelector('summary');
      summary.addEventListener('click', function() {
        setTimeout(function() {
          if (item.open) {
            item.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest' 
            });
          }
        }, 100);
      });
    });
  }
  
  // Additional collection-specific JavaScript can go here
  console.log('Collections page JavaScript loaded');
});


// document.addEventListener('DOMContentLoaded', function() {
  
//   // Check for faq-demo query parameter
//   function checkFAQDemo() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const faqSection = document.querySelector('.faq-section');
    
//     if (faqSection) {
//       if (urlParams.has('faq-demo')) {
//         faqSection.style.display = 'block';
//         // Optional: smooth scroll to FAQ section
//         setTimeout(() => {
//           faqSection.scrollIntoView({ behavior: 'smooth' });
//         }, 100);
//       } else {
//         // faqSection.style.display = 'none';
//       }
//     }
//   }
  
//   // Check on page load
//   checkFAQDemo();
  
//   // Check when URL changes (for single page apps)
//   window.addEventListener('popstate', checkFAQDemo);
  
//   // Your existing FAQ accordion code...
//   const faqItems = document.querySelectorAll('.faq-item');
  
//   if (faqItems.length > 0) {
//     faqItems.forEach(function(item) {
//       item.addEventListener('toggle', function() {
//         if (this.open) {
//           faqItems.forEach(function(otherItem) {
//             if (otherItem !== item && otherItem.open) {
//               otherItem.open = false;
//             }
//           });
//         }
//       });
//     });
//   }
// });